module.exports = __webpack_public_path__ + "static/media/speed.c80dd3ba.svg";